export class User {
    username: string; 
    subject: string;
    email: string;
    
    constructor(user?: User) {
        // This handles copying the simple properties
        if (!user) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(user).forEach(key => {
            this[key] = user[key];
        });
    }
}